import React, {Component} from "react";

import style from './_modal.module.scss';

import Row from "../Layout/Row";
import ElementModal from "./ElementModal";
let classNames = require('classnames');

export default class EditLabelModal extends Component {
	state = {};

	submit = () => {
		this.props.onSubmit(this.state.label);
	};

	render() {

		let {isOpen, onClose} = this.props;
		let className = classNames(style.modal);
		return (
			<ElementModal isOpen={isOpen} onClose={onClose} className={className} error={this.state.error} reset={() => this.setState({label:undefined})} submit={this.submit}>
				<Row className={style.fields}>
					<input
						type={"text"}
						placeholder={this.props.placeholder || "Nome dispositivo"}
						onChange={(e) => this.setState({label:e.target.value})}/>
				</Row>
			</ElementModal>
		);
	}
}
